import React, { useState, useEffect, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import { createModal } from "react-modal-promise";
import { useAxiosWithAuthorization } from "../../../utils/api";
import useAppContext from "../../../utils/Reducers";

const RealVenderInfoPop = ({ vndrCd, rvndrCd }) => {
  //공급업체 검색 URL
  const SERARCH_REALVENDOR_URL = "/company/searchRealVendorInfo.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_REALVENDOR_URL,
    },
    { manual: true }
  );
  const initItem = {
    systemCd: "",
    vndrCd: "",
    vndrNm: "",
    rvndrCd: "",
    rvndrNm: "",
    addr: "",
    addrDesc: "",
    latt: "",
    lont: "",
    bsnsNo: "",
    telNo: "",
    mngrNm: "",
    mngrTel: "",
    statusCd: "",
    useYn: "",
    note: "",
    firstYn: "",
  };
  const [fieldValues, setFieldValues] = useState(initItem);
  const [show, setShow] = useState(true);
  const {
    store: { userInfo },
  } = useAppContext();

  const handleClose = (returnData) => {
    setShow(false);
  };

  const handleOk = (returnData) => {
    setShow(false);
  };

  const handleSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      params: {
        schVndrCd: vndrCd,
        schRvndrCd: rvndrCd,
      },
    });

    //console.log(data);
    setFieldValues(data[0]);
  };

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    handleSearch();
    //
  }, []);

  return (
    <>
      <Modal show={show} onHide={() => handleClose(false)}>
        <Modal.Header closeButton>
          <Modal.Title>실공급업체정보</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchdata">
            <table className="t_garo">
              <tr>
                <th>공급업체명</th>
                <td style={{ width: "200px" }}>{fieldValues?.vndrNm}</td>
                <th>실공급업체명</th>
                <td style={{ width: "200px" }}>{fieldValues?.rvndrNm}</td>
              </tr>
              <tr>
                <th>주소1</th>
                <td style={{ width: "200px" }}>{fieldValues?.addr}</td>
                <th>주소2</th>
                <td style={{ width: "200px" }}>{fieldValues?.addrDesc}</td>
              </tr>
              <tr>
                <th>사업자번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.bsnsNo}</td>
                <th>전화번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.telNo}</td>
              </tr>
              <tr>
                <th>관리자</th>
                <td style={{ width: "200px" }}>{fieldValues?.mngrNm}</td>
                <th>관리자전화번호</th>
                <td style={{ width: "200px" }}>{fieldValues?.mngrTel}</td>
              </tr>
              <tr>
                <th>비고</th>
                <td style={{ width: "200px" }}>{fieldValues?.note}</td>
              </tr>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleOk(true)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export const ModalRealVenderInfoPop = createModal(RealVenderInfoPop);

export default RealVenderInfoPop;
